import { Button, Grid } from "@mui/material";
import React from "react";
import Fonts from "../../Config/Fonts";
import Colors from "../../theme/Colors";

const CustomButton = ({ handleSubmit, isCancelBtn = false , label}) => {
  return (
    <Grid item xs={14} style={{ display: "flex", justifyContent: "end", width: '100%' }}>
      {isCancelBtn && (
        <div style={cancelBtnView}>
          <Button type="button" onClick={handleSubmit} sx={btnStyle}>
            Cancel
          </Button>
        </div>
      )}
      <Button type="submit" onClick={handleSubmit} sx={btnStyle}>
        {label}
      </Button>
    </Grid>
  );
};

const btnStyle = {
  backgroundColor: Colors.darkBlue,
  color: Colors.white,
  height: "43px",
  width: "25vh",
  padding: '10px 40px',
  border: "1px solid #4A505C",
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins, // Ensure this matches the loaded font
  marginTop: "10px",
  "&:hover": {
    backgroundColor: Colors.primaryColor,
    color: Colors.white,
    border: "0px",
  },
  transition: "background-color 0.3s, color 0.3s", // Optional: for smooth transition
};

const cancelBtnView = {
    marginRight: '15px'
}

export default CustomButton;
